import React from 'react';
import SectionHeader from '../../common/SectionHeader/SectionHeader';
import LifeCarousel from '../LifeCarousel/LifeCarousel';
import ExperienceItem from './ExperienceItem';
import styles from './AboutAnnie.module.css';

const credentials = [
  { label: 'Chứng chỉ', value: 'JLPT N1' },
  { label: 'TOEIC', value: '900+' },
];

/**
 * About Annie section — centered header + balanced grid layout.
 */
function AboutAnnie() {
  return (
    <section className={`section bg-cream ${styles.outer}`} aria-label="Về Annie">
      <div className="container">
        <SectionHeader
          label="Về Annie"
          title=""
          center
        />
        <div id="about-annie" className={styles.cardWrapper}>
          <div className={styles.grid}>
            <div className={styles.bio}>
              <ExperienceItem
                icon={
                  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                    <path d="M2 3h6a4 4 0 0 1 4 4v14a3 3 0 0 0-3-3H2z"></path>
                    <path d="M22 3h-6a4 4 0 0 0-4 4v14a3 3 0 0 1 3-3h7z"></path>
                  </svg>
                }
                label="SINH VIÊN TRAO ĐỔI"
                title="Ibaraki Christian University"
                description="Cựu sinh viên trao đổi tại Nhật Bản — GPA 3.6/4.0"
              />

              <ExperienceItem
                icon={
                  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                    <rect x="2" y="7" width="20" height="14" rx="2" ry="2"></rect>
                    <path d="M16 21V5a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v16"></path>
                  </svg>
                }
                label="HỌC BỔNG 2018"
                title="METI Japan Internship Program"
                description="Được tài trợ bởi Bộ Kinh tế, Thương mại và Công nghiệp Nhật Bản."
              />

              <ExperienceItem
                icon={
                  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                    <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"></path>
                    <polyline points="22 4 12 14.01 9 11.01"></polyline>
                  </svg>
                }
                label="THÁNG 7/2022 - VIỆT NAM"
                title="Chứng chỉ JLPT N1"
              />

              <ExperienceItem
                icon={
                  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                    <rect x="2" y="7" width="20" height="14" rx="2" ry="2"></rect>
                    <path d="M16 21V5a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v16"></path>
                  </svg>
                }
                label="7+ NĂM"
                title="Phiên dịch viên Anh – Nhật"
                description="Kinh nghiệm chuyên nghiệp tại các tập đoàn Nhật Bản và công ty toàn cầu trong nhiều lĩnh vực đa dạng."
              />
            </div>

            <div className={styles.divider}></div>

            <div className={styles.card}>
              <div className={styles.avatarWrapper}>
                <img
                  src={`${process.env.PUBLIC_URL}/images/annie-profile.jpg`}
                  alt="Annie Hồ"
                  className={styles.avatarImg}
                />
              </div>
              <div className={styles.name}>Annie Hồ</div>
              <div className={styles.role}>Giáo viên TOEIC &amp; JLPT</div>
              <dl className={styles.credGrid}>
                {credentials.map((c) => (
                  <div key={c.label} className={styles.credItem}>
                    <dt className={styles.credLabel}>{c.label}</dt>
                    <dd className={styles.credValue}>{c.value}</dd>
                  </div>
                ))}
              </dl>
            </div>
          </div>
        </div>

        {/* Life Carousel */}
        <div className={styles.carouselSection}>
          <LifeCarousel />
        </div>
      </div>
    </section>
  );
}

export default AboutAnnie;
